import ApplicationForm from './components/ApplicationForm'
import { Toaster } from './components/ui/sonner'

function App() {
  return (
    <div className="min-h-screen bg-[#f5f5f5] font-verona">
      <ApplicationForm />
      <Toaster />
    </div>
  )
}

export default App